$(document).ready(function() {

	let ACTION_TO_CLINICS_LISTING = "action-to-clinics-listing";
	let SELECT_CLINIC = "select-clinic";
	let REASON_REJECT_MODAL = "#reason_reject_modal";
	let SEND_REJECT_REASON = "#send-reject-reason";
	let REASON_REJECT = "#reason-reject";

	let URL_APPROVE_CLINICS = "/approve_clinics";
	let URL_REJECT_CLINICS = "/reject_clinics";

	function selectedClinicIds() {
		return $('.' + SELECT_CLINIC + ':checkbox:checked').map(function() {
			return this.value;
		}).get().join(",");
	}

	$(document).on('click', '.' + ACTION_TO_CLINICS_LISTING, function() {
		let clinics_ids = selectedClinicIds();
		if (clinics_ids === "") {
			alert("Selecione ao menos 1 clínica");
			return;
		}
		if (this.id === "approve-clinics") {
			approveSelectedClinics(clinics_ids);
		} else if (this.id === "reject-clinics") {
			$(REASON_REJECT_MODAL).modal('show');
			$(REASON_REJECT).focus();
		}
	});

	function approveSelectedClinics(clinics_ids) {
		if (!window.confirm("Você tem certeza?")) { return; }
		$.ajax({
			url: URL_APPROVE_CLINICS,
			method: 'POST',
			dataType: 'json',
			data: { clinics_ids: clinics_ids },
			success: function(data) {
				alert(data.message);
				if (data.result) { window.location = window.location; }
			}
		});
	}

	// O motivo e OPCIONAL: diferente da reprovacao de usuario, aqui o envio
	// acontece com o campo vazio. E o card que define assim.
	$(document).on('click', SEND_REJECT_REASON, function() {
		let clinics_ids = selectedClinicIds();
		if (clinics_ids === "") { return; }
		if (!window.confirm("Você tem certeza?")) { return; }
		$.ajax({
			url: URL_REJECT_CLINICS,
			method: 'POST',
			dataType: 'json',
			data: { clinics_ids: clinics_ids, reject_reason: $(REASON_REJECT).val() },
			success: function(data) {
				alert(data.message);
				if (data.result) { window.location = window.location; }
			}
		});
	});

});
